import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";

const BannerPushNotification = ({ sleekNoteId, topMenu, children }) => {
  const [activeSleekNote, setActiveSleekNote] = useState(false);

  const ref = useRef();
  useEffect(() => {
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // console.log('A child node has been added or removed.');
          const { addedNodes } = mutation;
          if (addedNodes?.length) {
            for (const elem of addedNodes) {
              /* if (isRobotoStyle(elem)) {
                elem.parentNode.removeChild(elem);
              } */
              console.log("AGGIUNTO NODO", elem);
              setActiveSleekNote(true);
              if (topMenu) {
                const { height } = ref.current.getBoundingClientRect();
                const event = new CustomEvent("banner-top-menu-resize", {
                  detail: {
                    height,
                  },
                });
                document.dispatchEvent(event);
              }
            }
          }
        }
      }
    });
    // Start observing the target node for configured mutations
    observer.observe(ref.current, { childList: true });
    // Later, you can stop observing
    return () => observer.disconnect();
  }, [topMenu]);

  return (
    <>
      <div
        id={sleekNoteId}
        ref={ref}
        className={classNames("product-list__sleeknote", {
          "d-none": !activeSleekNote,
        })}
      ></div>
      <div className={classNames("h-100", { "d-none": activeSleekNote })}>{children}</div>
    </>
  );
};

export default BannerPushNotification;
